import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  const links = [
    { to: "/", label: "Home" },
    { to: "/catalog", label: "Catalog" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass shadow-sm" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo">
          <Logo size={44} />
        </Link>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm tracking-wide uppercase transition-colors ${
                    isActive ? "text-[#2C4532] font-medium" : "text-[#4A4D4A] hover:text-[#2C4532]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <Link
            to="/contact"
            data-testid="nav-cta-quote"
            className="inline-flex items-center gap-2 rounded-full bg-[#2C4532] text-[#F9F8F6] px-6 py-3 text-xs uppercase tracking-[0.2em] hover:bg-[#1F3124] transition-all"
          >
            Request Quote
            <span className="text-[#D4AF37]">→</span>
          </Link>
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu" data-testid="nav-mobile-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass border-t border-[#EAE6DF]" data-testid="nav-mobile-menu">
          <ul className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink to={l.to} className="block py-2 text-sm uppercase tracking-[0.2em]">
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li>
              <Link to="/contact" className="inline-block rounded-full bg-[#2C4532] text-[#F9F8F6] px-5 py-3 text-xs uppercase tracking-[0.2em]">
                Request Quote →
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
